import React from "react";
import ContactForm from "./../Shared/contact-form";
import { Container, Col, Row } from "react-bootstrap";
import { Fade } from "react-reveal";

function Contact() {
  return (
    <section id="contact" className="black-text">
      <Container>
        <Row className="contact-row">
          <Col lg={6}>
            <Fade bottom duration={2000}>
              <h2 className="recipe-subheading text-center">CONTACT ME</h2>
              <p className="lined-p text-center contact-text">
                Feel free to leave me a message here or contact me at
                oceananddexterskitchen@gmail.com
              </p>
            </Fade>
          </Col>
          <Col lg={6}>
            <ContactForm />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Contact;
